function TableGroups({ groups, onAction, currentPage, setCurrentPage , hasManagementPermissions }) {
  const itemsPerPage = 5;
  const totalPages = Math.ceil(groups.length / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const visibleGroups = groups.slice(startIndex, startIndex + itemsPerPage);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <div className="ventana_resultado_visible">
      <div className="tabla">
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Grupo</th>
              {hasManagementPermissions && <th>Miembros</th>}
              {hasManagementPermissions && <th>Activo</th>}
              {hasManagementPermissions && <th>Acciones</th>}
            </tr>
          </thead>
          <tbody>
            {visibleGroups.map((group) => (
              <tr key={group.COD_ID || group.NOMBRE}>
                <td className="resuelta">
                  <i className="bi bi-check2-circle"></i>
                </td>
                <td>{group.NOMBRE}</td>
                {hasManagementPermissions && <td>{group.memberCount}</td>}
                {hasManagementPermissions && <td>
                  {group.ACTIVO === 1 || group.ACTIVO === "1" ? "Sí" : "No"}
                </td>}
                {hasManagementPermissions && <td>
                  <i className="bi bi-three-dots-vertical">
                    <div className="acciones">
                      <span
                        className="item_acciones"
                        onClick={() =>
                          onAction("modificar-grupo", group.COD_ID)
                        }
                      >
                        Modificar grupo
                      </span>
                      <span
                        className="item_acciones"
                        onClick={() => onAction("eliminar-grupo", group.COD_ID)}
                      >
                        Eliminar grupo
                      </span>
                    </div>
                  </i>
                </td>}
              </tr>
            ))}
          </tbody>
        </table>
{hasManagementPermissions && <div className="input-group_2">
          <span
            className={`boton_opciones`}
            onClick={() => onAction("crear-grupo", null)}
          >
            Crear nuevo grupo
          </span>
        </div>
}
        

        {groups.length > 0 && (
          <div className="paginacion-control">
            <span
              className="boton_opciones"
              onClick={handlePreviousPage}
              disabled={currentPage === 1}
            >
              Anterior
            </span>
            <span className="pagina_info">
              Página {currentPage} de {totalPages || 1}
            </span>
            <span
              className="boton_opciones"
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
            >
              Siguiente
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

export default TableGroups;
